/** biome-ignore-all lint/suspicious/noEmptyBlockStatements: disabled */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type InfractionModuleFooterState = {
	hasDismissedFooter: boolean;
	dismissFooter: () => void;
};

export const useInfractionModuleFooterStore =
	create<InfractionModuleFooterState>()(
		persist(
			(set) => ({
				hasDismissedFooter: false,
				dismissFooter: () => {
					set({ hasDismissedFooter: true });
				},
			}),
			{
				name: "infraction-module-footer-storage",
				storage: createJSONStorage(() => {
					if (typeof window === "undefined") {
						return {
							getItem: () => null,
							setItem: () => {},
							removeItem: () => {},
						};
					}

					return localStorage;
				}),
				partialize: (state) => ({
					hasDismissedFooter: state.hasDismissedFooter,
				}),
			}
		)
	);
